import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import FinishedBidsSection from '../components/FinishedBids'
import ScrollToTop from '../components/ScrollToTop'

function FinishedBidsPage() {

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <FinishedBidsSection />

            <Footer />
        </div>
    )
}

export default FinishedBidsPage